<template>
  <v-container fluid>

    <v-dialog transition="dialog-bottom-transition" max-width="800" v-if="modalRole" v-model="modalRole">
      <template v-slot:default>
        <v-card>
          <v-card-title class="primary lighten white--text">{{ modalTitle }}
            <v-spacer></v-spacer>
            <v-btn text class="litte white--text" @click="closeRoleModal()">
              <v-icon white>mdi-window-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>

            <v-form ref="form" v-model="validForm" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Nome do Perfil" v-model="editedItem.name" placeholder="Nome"
                    :rules="rulesRequired"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <function-selector :features="featuresData"  :selected-features.sync="selectedFeatures"></function-selector>
                </v-col>

              </v-row>
            </v-form>

          </v-card-text>

          <v-card-actions class="justify-end">

            <v-btn :loading="loading.modalRole" text @click="save()"> {{modalTitle == "Editar Perfil"? 'Editar':'Salvar'}}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card style="border-radius: 20px">

          <v-row style="justify-content: space-between">
            <v-card-title class="title-displays"> Permissões </v-card-title>
            <v-card-title>
              <v-btn right @click="openCreateRoleModal()" color="primary" text>
                <v-icon> add </v-icon>
                Adicionar Perfil
              </v-btn>
            </v-card-title>
            <v-text-field style="width:80%; padding:1em" class="px-4" prepend-icon="search" label="Busca"
              v-model="searchText"></v-text-field>
            <v-select hint="Buscar nessa coluna" persistent-hint style="width:20%; padding: 1em"
              v-model="columnToSearch" :items="columnsToChoose" return-object single-line></v-select>
          </v-row>


          <v-data-table :loading="loading.mainTable" :items="filteredItems" :headers="headers" :footer-props="{
            'items-per-page-options': [5, 10, 20, 30]
          }" no-data-text="Sem Perfis para exibir">

            <template v-slot:item.actions="{ item }">
              <span style="display: flex; justify-content: center; align-items: center; gap: 4px; width: 100%;">
                <v-icon small color="primary" class="mr-2" @click="selectAction(item, 'edit')">
                  mdi-pencil
                </v-icon>
                <v-icon small color="error" @click="selectAction(item, 'delete')">
                  mdi-delete
                </v-icon>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alertscript from './RolesScript';
export default Alertscript;
</script>


<style scoped lang="scss">
.title-displays {
  font-size: 25px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
